
import { Section } from "./data-types";

export const StudyHigherEducation: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Higher Education",
						content: () => [
							<p>
								Geography can be studied by many of Ireland's universities, as a single subject, or as part of a wider degree:
							</p>,
							<ul>
								<li><a href="https://www.tcd.ie/geography/">Trinity College Dublin (TCD)</a></li>
								<li><a href="https://www.ucd.ie/geography/">University College Dublin (UCD)</a></li>
								<li><a href="https://www.maynoothuniversity.ie/geography">Maynooth University</a></li>
								<li><a href="https://www.ul.ie/courses/geography">University of Limerick (UL)</a></li>
								<li><a href="https://www.mic.ul.ie/faculty-of-arts/department/geography?index=0">Mary Immaculate College (MIC) Limerick</a></li>
								<li><a href="https://www.universityofgalway.ie/geography/">University of Galway</a></li>
								<li><a href="https://www.ucc.ie/en/geography/">University College Cork (UCC)</a></li>
								<li><a href="https://www.dcu.ie/historygeography">Dublin City University (DCU)</a></li>
								<li><a href="https://www.atu.ie/courses/bachelor-of-arts-honours-geography-and-outdoor-education">Atlantic Technological University (ATU)</a></li>
							</ul>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/6.jpg"
						},
					},
				}
			]
		}
	]
}
